// ----------------------------------------------------------------------

const account = {
  displayName: "Admin",
  email: "shubham@blocys.com",
  photoURL: "/static/mock-images/avatars/avatar_9.jpg",
};

export default account;
